/**
 * `AddWorkplaceForm` — вариант «Добавление» shared-компонента [`WorkplaceForm`](./workplace-form.tsx)
 * (centrika-docs!78, `component.workplace.form`). Тонкая обёртка сохранена для существующих точек
 * входа (`AddToStructureModal` на /ot, `StructureManager` в «Сотрудники»/team-«Структура») и их
 * контракта `onCreated`; вся логика формы (поля места + режим работы + сотрудник/сменщик, единые
 * правила подразделения/должности/сохранения) живёт в `WorkplaceForm`.
 */
import { type CompanyScopeApi, type Department, type Employee, type Workplace } from '@/lib/api'
import { WorkplaceForm } from './workplace-form'

export interface AddWorkplaceFormProps {
  api: CompanyScopeApi
  /** Существующие подразделения структуры — выбор/ввод в поле «Подразделение» (centrika-docs!61). */
  departments: Department[]
  /** Существующие сотрудники структуры — выбор основного сотрудника места и сменщика (§7.1). */
  employees: Employee[]
  /** Рабочее место создано (композитный ответ — employee/shiftPartner заполнены, если заданы). */
  onCreated: (workplace: Workplace) => void
  /** Отмена — без побочных эффектов; когда закрытие есть у контейнера, проп не передаётся. */
  onCancel?: () => void
  className?: string
}

export function AddWorkplaceForm({ onCreated, ...rest }: AddWorkplaceFormProps) {
  return <WorkplaceForm variant="create" onSaved={onCreated} {...rest} />
}
